/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemForms } from '../../models/system-forms';
import { SystemFormsCreate } from '../../models/system-forms-create';

export interface CreateSystemFormsInternalV2SystemFormsPost$Params {
  org: string;
      body: SystemFormsCreate
}

export function createSystemFormsInternalV2SystemFormsPost(http: HttpClient, rootUrl: string, params: CreateSystemFormsInternalV2SystemFormsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemForms>> {
  const rb = new RequestBuilder(rootUrl, createSystemFormsInternalV2SystemFormsPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemForms>;
    })
  );
}

createSystemFormsInternalV2SystemFormsPost.PATH = '/_internal/v2/system-forms';
